import { render, staticRenderFns } from "./SacChamadoPrincipal.vue?vue&type=template&id=5227c43a&"
import script from "./SacChamadoPrincipal.vue?vue&type=script&lang=js&"
export * from "./SacChamadoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports